// Timer starten buiten de taaklade (Mijn werk): eerst de omschrijving, zoals in het tabblad Uren. Elke registratie
// wordt verantwoord; zonder tekst start de timer niet. Heeft de taak meerdere Clockify-taken, dan kiest u er een.
// Enter start, Escape sluit.
import { useState } from "react";
import { Icon } from "../lib/icons";
import type { Task } from "../lib/types";

export function TimerAsk({ task, sub, options, busy, onStart, onClose }: {
  task: Task;
  /** klant of andere context onder de titel */
  sub: string;
  /** de Clockify-taken van de taak, als het er meerdere zijn */
  options: { id: string; name: string }[];
  busy: boolean;
  onStart: (description: string, clockifyTaskId?: string) => Promise<unknown>;
  onClose: () => void;
}) {
  const [d, setD] = useState("");
  const [on, setOn] = useState(options[0]?.id || "");
  const go = () => { const v = d.trim(); if (v && !busy) onStart(v, options.length > 1 ? on : undefined).then(onClose).catch(() => {}); };
  return (
    <>
      <button type="button" className="p-scrim" aria-label="Sluiten" onClick={onClose} />
      <div className="p-ask" role="dialog" aria-modal="true" aria-labelledby="ask-h">
        <h2 id="ask-h">Waaraan werk je?</h2>
        <p>{task.title}{sub ? " · " + sub : ""}</p>
        <input className="ex-input" autoFocus maxLength={500} aria-label="Omschrijving" placeholder="Bijvoorbeeld: statusmapping testen met de klant" value={d}
          onChange={(e) => setD(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") go(); if (e.key === "Escape") onClose(); }} />
        {options.length > 1 && (
          <select className="ex-input" aria-label="Op welke Clockify-taak" value={on} onChange={(e) => setOn(e.target.value)}>
            {options.map((o) => <option key={o.id} value={o.id}>op {o.name}</option>)}
          </select>
        )}
        <div className="p-ask-f">
          <button type="button" className="ex-btn" onClick={onClose}>Annuleren</button>
          <button type="button" className="ex-btn ex-btn--primary" disabled={!d.trim() || busy} onClick={go}><Icon name="play" size={14} />Timer starten</button>
        </div>
      </div>
    </>
  );
}
